import Box from "@mui/material/Box";
import EmailContentHeader from "./EmailContentHeader";
import EmailContent from "./EmailContent";

const EmailItemDetails = ({
  handleToggleView,
  user,
  openReply,
  handleOpenReply,
  handleCloseReply,
}: any) => {
  return (
    <Box
      sx={{
        boxShadow: openReply ? "none" : "0px 12px 24px 0px #00000040",
        marginBottom: "10px",
        borderRadius: "8px",
        border: "2px solid rgba(60, 64, 67, 0.47)",
      }}
    >
      <Box
        sx={{
          borderRadius: "8px",
          padding: "15px",
        }}
      >
        <EmailContentHeader handleToggleView={handleToggleView} user={user} />
        <Box
          sx={{
            padding: "30px",
          }}
        >
          <EmailContent
            openReply={openReply}
            handleOpenReply={handleOpenReply}
            handleCloseReply={handleCloseReply}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default EmailItemDetails;
